export default __webpack_public_path__ + "static/media/overpay.5022fc02.png";